import React, { useContext, useState } from "react";
import firebase from "firebase/app";
import "firebase/auth";
import firebaseConfig from "./firebase.config";
import UserContext from "../../userContext";
import { useHistory, useLocation } from "react-router";
import { Button, Form } from "react-bootstrap";
import "./Login.css";
import { Link } from "react-router-dom";

const Login = () => {
  const [newRider, setNewRider] = useState(true);
  const [user, setUser] = useState({
    isSignedIn: false,
    name: "",
    email: "",
    password: "",
    error: "",
    success: false,
  });
  const [loggedInUser, setLoggedInUser] = useContext(UserContext);
  const history = useHistory();
  const location = useLocation();
  const { from } = location.state || { from: { pathname: "/" } };
  if (firebase.apps.length === 0) {
    firebase.initializeApp(firebaseConfig);
  }
  const handleGoogleSignIn = () => {
    var provider = new firebase.auth.GoogleAuthProvider();
    firebase
      .auth()
      .signInWithPopup(provider)
      .then((result) => {
        const { displayName, email } = result.user;
        const signedInUser = { name: displayName, email };
        setLoggedInUser(signedInUser);
        history.replace(from);
        // ...
      })
      .catch((error) => {
        
      });
  };
  const handleNewRider = () => {
    setNewRider(false);
  };
  const handleSignUp = () => {
    setNewRider(true);
  };

  const handleSubmit = (e) => {
    if (newRider && user.email && user.password) {
      firebase
        .auth()
        .createUserWithEmailAndPassword(user.email, user.password)
        .then((response) => {
          const newUserInfo = { ...user };
          newUserInfo.error = "";
          newUserInfo.success = true;
          setUser(newUserInfo);
          updateUserInfo(user.name);
          console.log(newUserInfo);
        })
        .catch((error) => {
          const newUserInfo = { ...user };
          newUserInfo.error = error.message;
          newUserInfo.success = false;
          setUser(newUserInfo);
        });
    }

    if (!newRider && user.email && user.password) {
      firebase
        .auth()
        .signInWithEmailAndPassword(user.email, user.password)
        .then((response) => {
          const {displayName, email} = response.user;
          const newUserInfo = {
            name: displayName,
            email: email
          };
          newUserInfo.error = "";
          newUserInfo.success = true;
          setUser(newUserInfo);
          setLoggedInUser(newUserInfo);
          history.replace(from);
        })
        .catch((error) => {
          const newUserInfo = { ...user };
          newUserInfo.error = error.message;
          newUserInfo.success = false;
          setUser(newUserInfo);
        });
    }
    e.preventDefault();
  };
  const handleBlur = (e) => {
    let isFieldValid = true;
    if (e.target.name === "email") {
      isFieldValid = /\S+@\S+\.\S/.test(e.target.value);
    }

    if (e.target.name === "password") {
      const isPasswordValid = e.target.value.length > 7;
      const passwordHasNumber = /\d{2}/.test(e.target.value);
      isFieldValid = isPasswordValid && passwordHasNumber;
    }
    if (isFieldValid) {
      const newUserInfo = { ...user };
      newUserInfo[e.target.name] = e.target.value;
      setUser(newUserInfo);
    }
    console.log(e.target.name, e.target.value);
  };
  const updateUserInfo = (name) => {
    const user = firebase.auth().currentUser;

    user
      .updateProfile({
        displayName: name,
  
      })
      .then(function () {
        console.log('user name updated successfully');
      })
      .catch(function (error) {
        console.log(error);
      });
  };
  return (
    <div className="container col-sm-12">
      <div className="signup-form">
        {newRider && (
          <Form onSubmit={handleSubmit}>
            <h3>Create Account</h3>
            <Form.Group controlId="formBasicName">
              <Form.Label>Name</Form.Label>
              <Form.Control
                onBlur={handleBlur}
                name="name"
                type="text"
                placeholder="Enter your name"
                required
              />
            </Form.Group>
            <Form.Group controlId="formBasicUserName">
              <Form.Label>Email</Form.Label>
              <Form.Control
                onBlur={handleBlur}
                name="email"
                type="text"
                placeholder="Enter your Email"
                required
              />
            </Form.Group>

            <Form.Group controlId="formBasicPassword">
              <Form.Label>Password</Form.Label>
              <Form.Control
                onBlur={handleBlur}
                name="password"
                type="password"
                placeholder="Password"
                required
              />
            </Form.Group>
            <Form.Group controlId="formBasicConfirmPassword" className="mb-2">
              <Form.Label>Confirm Password</Form.Label>
              <Form.Control
                onBlur={handleBlur}
                name="Confirm Password"
                type="password"
                placeholder="confirmPassword"
                required
              />
            </Form.Group>

            <Button variant="primary" type="submit">
              Create an Account
            </Button>
            <p style={{ color: "red" }}>{user.error}</p>
            {user.success && (
              <p style={{ color: "green" }}>User Created Successfully</p>
            )}
            <p>
              Already have an account?{" "}
              <Link onClick={handleNewRider}>Sign In</Link>
            </p>
          </Form>
        )}
        {!newRider && (
          <Form onSubmit={handleSubmit}>
            <h3>Login</h3>
            <Form.Group controlId="formBasicUserName">
              <Form.Label>Email</Form.Label>
              <Form.Control
                onBlur={handleBlur}
                name="email"
                type="text"
                placeholder="Enter your Email"
                required
              />
            </Form.Group>
            <Form.Group controlId="formBasicPassword" className="mb-2">
              <Form.Label>Password</Form.Label>
              <Form.Control
                onBlur={handleBlur}
                name="password"
                type="password"
                placeholder="Password"
                required
              />
            </Form.Group>
            <Button variant="primary" type="submit" className="mb-2">
              Login
            </Button>
            {/* {user.success && (
              <p style={{ color: "green" }}>Logged In Successfully</p>
            )} */}
            <p>
              If you don't have an account?{" "}
              <Link onClick={handleSignUp}>Sign Up</Link>
            </p>
          </Form>
        )}
      </div>
      <div className="social-login">
        <button onClick={handleGoogleSignIn}>Google Sign In</button>
      </div>
    </div>
  );
};

export default Login;
